import React, { useEffect, useState } from "react";

export const AboutUs = () => {
  const [aboutData, setAboutData] = useState([]);
  const [extraDetails, setExtraDetails] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          "https://webadmin.rigve.com/api/get_about",
        );
        const result = await response.json();
        if (result.status === 1) {
          setAboutData(result.data);
          setExtraDetails(result.extra_details);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <section id="about" className="px-4">
      <div className="relative from-white max-w-7xl mx-auto bg-gray-50 m py-16 px-6 md:px-16 overflow-hidden">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h1 className="fs-21 font-bold text-gray-900">
            About{" "}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-500 to-orange-600">
              Our Brand
            </span>
          </h1>
          <div className="w-24 h-1 bg-orange-500 mx-auto my-4 rounded-full"></div>
          <p className="mt-4 text-gray-600 text-lg">
            We specialize in premium textures and architectural surfaces
            designed to bring elegance, durability, and timeless beauty to
            modern spaces.
          </p>
        </div>
        {/* MAIN CONTENT */}
        <div className="grid lg:grid-cols-2 gap-12">
          {/* TEXT CONTENT */}
          <div className="text-left">
            <p className="text-orange-500 font-semibold mb-3">
              {aboutData[0]?.sub_title}
            </p>

            <h2 className="text-md font-bold text-gray-900 mb-6">
              {aboutData[0]?.title}
            </h2>

            <div className="space-y-4 text-gray-700 leading-relaxed">
              {aboutData[0]?.description
                ?.split("\r\n\r\n")
                .map((paragraph, index) => (
                  <p key={index}>{paragraph}</p>
                ))}
            </div>
          </div>

          {/* IMAGE SECTION */}
          <div className="relative">
            <div className="rounded-3xl overflow-hidden shadow-xl">
              <img
                src={aboutData[0]?.image}
                alt="Premium texture and architectural surface design"
                className="w-full h-[450px] object-cover"
                loading="lazy"
              />
            </div>

            {/* FLOATING CARD */}
            <div className="absolute -bottom-8 left-6 right-6 bg-white/70 backdrop-blur-lg shadow-lg p-6 rounded-2xl border border-white/30">
              <p className="text-gray-900 font-semibold text-sm">
                {aboutData[0]?.image_title}
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* HEADER (SEO) */}
    </section>
  );
};
